import { render, staticRenderFns } from "./multipane-resizer.vue?vue&type=template&id=01fe7694&scoped=true"
var script = {}
import style0 from "./multipane-resizer.vue?vue&type=style&index=0&id=01fe7694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe7694",
  null
  
)

export default component.exports